<!--Menu: 体验中心-菜单 2020/08/26 15:06:49 Sunanguang-->

<template>
   <div class="its-menu">
     <div class="its-menu-item" v-for="(tab, i) in tabs" :key="'tab-'+i" @click="menuClick(tab.item)" :class="{'active':activeTab==tab.item.key}">
       <i class="its-icon" :class="tab.icon"></i>
       {{tab.mainTitle}}
     </div>
   </div>
</template>
<script>
export default {
  name: 'Menu',
  props: {
    tabs:  {
      type: Array,
      default: function () {
          return []
      }
    },
    fatherAction: {
      type: Function,
      default: null
    } 
  },
  data () {
    return {
      activeTab: 1
    }
  },
  created () {
     // 请求接口
  },
  mounted () {
     // 更新Dom
  },
  methods: {
     menuClick: function (action) {
       this.activeTab = action.key
       if(this.fatherAction) {
         this.fatherAction(action)
       }
     }
  }
}
</script>

<style scoped>
.its-menu {
  position: fixed;
  left: 108px;
  top: 50%;
  margin-top: -92.5px;
  z-index: 1000;
}
.its-menu-item {
  width: 170px;
  height: 40px;
  line-height: 40px;
  border: 1px solid rgba(67,144,255,0.3);
  color: #4390FF;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  margin: 5px 0;
}
.its-menu-item i {
  margin-right: 20px;
}
.its-menu-item:hover,
.its-menu-item.active {
  background: rgba(67,144,255,0.1);
  border: 1px solid rgba(67,144,255,0.1);
}
</style>